(function () {
  'use strict';

  function init() {
    const sections = document.querySelectorAll('[data-accordion-list]');
    if (sections.length === 0) return;

    sections.forEach((section) => {
      const items = section.querySelectorAll('[data-accordion-item]');
      if (items.length === 0) return;

      items.forEach((item) => {
        const link = item.querySelector('[data-accordion-link]');
        const content = item.querySelector('[data-accordion-content]');

        link.addEventListener('click', (event) => {
          event.preventDefault();

          if (link.getAttribute('aria-expanded') === 'false') {
            openItem(link, content);

            // DATALAYER
            app.dataLayer.pushEvent('accordionOpen', {
              pageUrl: window.location.pathname,
              option: link.innerText,
            });
          } else {
            closeItem(link, content);
          }
        });
      });
    });
  }

  function openItem(link, content) {
    if (link.getAttribute('data-sliding') === 'true') return;

    // a11y: update aria attributes
    link.setAttribute('data-sliding', true);
    link.setAttribute('aria-expanded', true);
    content.setAttribute('aria-hidden', false);

    util.slideDown(content, 250, () => {
      link.removeAttribute('data-sliding');
      // content.setAttribute('tabindex', 0);
    });
  }

  function closeItem(link, content) {
    if (link.getAttribute('data-sliding') === 'true') return;

    // a11y: update aria attributes
    link.setAttribute('data-sliding', true);
    link.setAttribute('aria-expanded', false);
    content.setAttribute('aria-hidden', true);

    util.slideUp(content, 250, () => {
      link.removeAttribute('data-sliding');
      // content.removeAttribute('tabindex');
    });
  }

  init();
})();
